module.exports = __webpack_public_path__ + "img/chevron-izq.930120af.svg";